module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAARCAYAAAA/mJfHAAABJklEQVQ4jdXTvUpcYRSF4TX+IQYVAgFBUoqNYGOpQpogBFLY2Vl4BSHegYidjRcgoqD2kiYYkTSmDdgYiKJWErBSIepjcwYOx1FwpnJ1+1uLd+/vL2lSeIt9/MU1Vppl1YEfChBst7VES4aTtCc5STLQylTT+I8ZjGKhqckwkWQjyXySj0m+J3lTDb3DFww9AxrBJZawqKRyqB8H+Fd4PzGHvlLmPc6wik8qqod68AO/MYyxovM5rrCOzzjEN3Ri9hEMXdjBH0ziAkdFk3ZMYRM3+IWewmsI28IpxostwHGDs+pFd6l+BOtIcptkJslaksEGkK9JRkr1bq1WW3vuqpcrTY5L3l7FW31qsvo7qz3Z6QVq9Tu9MthtZb1c31W8uwaZJLl/AIkAi64z33kEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/general-icons/icon_dashboard.png
// module id = 665
// module chunks = 0